import React from "react";
import PropTypes from "prop-types";
import {
  isConnectionPasswordVisible,
  STATUS_LABELS,
} from "../../../../components/Utils";
import { InputText, Label } from "../../../../components/Inputs";
import { PermissionResource, Resources } from "../../../Permissions";
import { ADConnectionPanel } from "../wizard/ADConnectionListForm";
import { DelphiConnectionPanel } from "../wizard/Connection";

export default class ITConnectionPanel extends React.Component {
  static propTypes = {
    className: PropTypes.string,
    model: PropTypes.shape({}),
    vfEmail: PropTypes.string,
    rows: PropTypes.number,
    children: PropTypes.node,
  };
  static defaultProps = {
    className: "",
    model: {
      ptConnection: "",
      ptUsername: "",
      adConnection: "",
      adUsername: "",
      delphiConnections: [],
    },
    vfEmail: "",
    rows: 10,
  };
  constructor() {
    super();
    this.state = { first: 0 };
  }
  onPage = (event) => {
    this.setState({ first: event.first });
  };
  render() {
    const { className, model, vfEmail, rows } = this.props;
    const {
      ptConnection,
      ptUsername,
      ptPassword,
      ptStatus,
      ptStatus_id,
      ptModified_date,
      delphiConnections,
      ...adModel
    } = model;
    const showADPassword =
      adModel.adPassword &&
      adModel.adPassword !== "" &&
      isConnectionPasswordVisible(adModel.adModified_date);
    const showPTPassword =
      ptPassword &&
      ptPassword !== "" &&
      isConnectionPasswordVisible(ptModified_date);
    const ptMarkup = !ptConnection || ptConnection.toLowerCase() !== "ja" ? null : (
      <PermissionResource
        resource={Resources.Profile.PTConnections}
      >
        <div className="w3-row">
          <div className="w3-col s2 pad-lr pad-sm-tb">
            <Label>{`Prov.-tool-Zugang`}</Label>
            <InputText className="w3-block" value={ptConnection} readonly />
          </div>
          <div className="w3-col s8 pad-lr">
            <div className="w3-row neg-margin-lr">
              <div className="w3-col s3 pad-lr pad-sm-tb">
                <Label>{`Kennung`}</Label>
                <InputText className="w3-block" value={ptUsername} readonly />
              </div>
              {showPTPassword && (
                <div className="w3-col s3 pad-lr pad-sm-tb">
                  <Label>{`Passwort`}</Label>
                  <InputText
                    className="w3-block"
                    value={ptPassword}
                    readonly
                  />
                </div>
              )}
            </div>
          </div>
          <div className="w3-col s2 pad-lr pad-sm-tb">
            <Label>{`Status`}</Label>
            <InputText
              className="w3-block"
              value={ptStatus || STATUS_LABELS[ptStatus_id]}
              readonly
            />
          </div>
        </div>
      </PermissionResource>
    );
    return (
      <div
        className={className}
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "16px",
        }}
      >
        <ADConnectionPanel
          model={{
            ...adModel,
            vf_email: vfEmail
          }}
          viewVFEmail/* ={viewVFEmail} */
          showPassword={showADPassword}
        />
        {ptMarkup}
        <DelphiConnectionPanel delphiConnections={delphiConnections} rows={rows} />
      </div>
    );
  }
}
